/* assets/wedyug-price-slider.js
   Dual-handle range slider layered over Dawn's native price inputs.
   The real inputs stay in the form (visually hidden via CSS) so Shopify
   filtering keeps working; the slider drives them and fires the events
   Dawn's facets.js already listens for. */
(function () {
  'use strict';

  function resolveMax(minInput, maxInput) {
    var candidates = [
      maxInput.getAttribute('data-max'),
      minInput.getAttribute('data-max'),
      maxInput.getAttribute('max'),
      maxInput.getAttribute('placeholder'),
      minInput.getAttribute('placeholder')
    ];

    for (var i = 0; i < candidates.length; i++) {
      if (!candidates[i]) continue;
      var n = Number(String(candidates[i]).replace(/[^\d.]/g, ''));
      if (n > 0) return Math.ceil(n);
    }
    return 0;
  }

  function currencySymbol(scope) {
    var text = (scope.textContent || '').match(/[₹$€£¥]/);
    return text ? text[0] : '₹';
  }

  function build(priceRange) {
    if (priceRange.dataset.wedyugSlider === 'ready') return true;

    var all = priceRange.querySelectorAll('input');
    if (all.length < 2) return false;

    var minInput = all[0];
    var maxInput = all[1];
    var rangeMax = resolveMax(minInput, maxInput);
    if (!rangeMax) return false;

    var symbol = currencySymbol(priceRange.closest('.facets__display-vertical') || priceRange);

    var wrap = document.createElement('div');
    wrap.className = 'wedyug-range';
    wrap.innerHTML =
      '<div class="wedyug-range__values">' +
        '<span class="wedyug-range__value wedyug-range__value--min"></span>' +
        '<span class="wedyug-range__value wedyug-range__value--max"></span>' +
      '</div>' +
      '<div class="wedyug-range__slider">' +
        '<div class="wedyug-range__track"><div class="wedyug-range__fill"></div></div>' +
        '<input type="range" class="wedyug-range__handle wedyug-range__handle--min" ' +
          'min="0" max="' + rangeMax + '" step="1" aria-label="Minimum price">' +
        '<input type="range" class="wedyug-range__handle wedyug-range__handle--max" ' +
          'min="0" max="' + rangeMax + '" step="1" aria-label="Maximum price">' +
      '</div>';

    priceRange.insertBefore(wrap, priceRange.firstChild);

    var fill = wrap.querySelector('.wedyug-range__fill');
    var lo = wrap.querySelector('.wedyug-range__handle--min');
    var hi = wrap.querySelector('.wedyug-range__handle--max');
    var outMin = wrap.querySelector('.wedyug-range__value--min');
    var outMax = wrap.querySelector('.wedyug-range__value--max');

    lo.value = Number(minInput.value) || 0;
    hi.value = Number(maxInput.value) || rangeMax;

    function fmt(n) {
      return symbol + Number(n).toLocaleString('en-IN');
    }

    function paint() {
      var a = Number(lo.value);
      var b = Number(hi.value);
      fill.style.left = (a / rangeMax) * 100 + '%';
      fill.style.width = ((b - a) / rangeMax) * 100 + '%';
      outMin.textContent = fmt(a);
      outMax.textContent = fmt(b);
    }

    function commit() {
      var a = Number(lo.value);
      var b = Number(hi.value);
      minInput.value = a > 0 ? a : '';
      maxInput.value = b < rangeMax ? b : '';
      minInput.dispatchEvent(new Event('change', { bubbles: true }));
      maxInput.dispatchEvent(new Event('input', { bubbles: true }));
    }

    lo.addEventListener('input', function () {
      if (Number(lo.value) >= Number(hi.value)) lo.value = Number(hi.value) - 1;
      paint();
    });

    hi.addEventListener('input', function () {
      if (Number(hi.value) <= Number(lo.value)) hi.value = Number(lo.value) + 1;
      paint();
    });

    // Commit on release only — dragging would otherwise fire one AJAX
    // request per pixel of movement.
    lo.addEventListener('change', commit);
    hi.addEventListener('change', commit);

    // Keep handles in sync if the hidden inputs change (e.g. filter reset)
    minInput.addEventListener('change', function () {
      lo.value = Number(minInput.value) || 0;
      paint();
    });

    maxInput.addEventListener('change', function () {
      hi.value = Number(maxInput.value) || rangeMax;
      paint();
    });

    paint();
    priceRange.dataset.wedyugSlider = 'ready';
    return true;
  }

  function init(root) {
    var nodes = (root || document).querySelectorAll('price-range');
    if (!nodes.length) return false;

    var allBuilt = true;
    for (var i = 0; i < nodes.length; i++) {
      if (!build(nodes[i])) allBuilt = false;
    }
    return allBuilt;
  }

  // Dawn's PriceRange custom element sets data-max on connectedCallback,
  // which can run after this script. Retry briefly rather than fail silently.
  function boot() {
    var tries = 0;
    (function attempt() {
      if (init() || tries++ > 20) return;
      setTimeout(attempt, 100);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Dawn replaces facet markup after each filter change — rebuild then.
  document.addEventListener('DOMContentLoaded', function () {
    var wrapper = document.getElementById('main-collection-filters');
    if (wrapper && window.MutationObserver) {
      new MutationObserver(function () {
        init(wrapper);
      }).observe(wrapper, { childList: true, subtree: true });
    }
  });
})();